// extracted by mini-css-extract-plugin
module.exports = {"image":"image_image__gT94m","contain":"image_contain__L3nxv","cover":"image_cover___CxoX","fill":"image_fill__XbeLM","right":"image_right__FZrP_","bottom":"image_bottom__xDSjv"};